// extracted by mini-css-extract-plugin
export default {"container":"FollowRow_container__ws4Iu","followers":"FollowRow_followers__uLYTh","accountHeader":"FollowRow_accountHeader__n1d-Y","headline":"FollowRow_headline__RixB1"};